import { Component, Inject } from '@angular/core';
import { JobLogService } from '../../../services/job-log.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'app-job-log',
    templateUrl: './job-log.component.html',
    styleUrls: ['./job-log.component.scss'],
    standalone: false // NOSONAR
})
export class JobLogComponent {
  successMessage: string | undefined;
  errorMessage: string | undefined;
  displaydata: any;
  errormsg: string | undefined;
  jobId: any;



  constructor(private readonly logservice: JobLogService, @Inject(MAT_DIALOG_DATA) public data: any,private readonly dialogRef:MatDialogRef<JobLogComponent> ) {
    this.jobId = data.jobId;
    
    this.apiCall(this.jobId);
  }

  apiCall(jobId: any) {

    this.logservice.getJobLog(jobId).subscribe(
      (response: any) => {
        this.displaydata = response.liosLogList;
      }, _error => {
        this.errormsg = "error00"
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, 5000);
      }
    );
  }

  closeDialog(){ this.dialogRef.close();}
}
